import React, { Component } from 'react'
import { connect } from 'react-redux'
import IndependentRefundSample from '../samples/IndependentRefundSample'
import { makeIndependentRefund } from '../../../actions/mcpActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _MCP, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    
    order_ID: ["mcpIndrefund.SetOrderId(order_id);", "mcpIndrefund.setOrderId(order_id);", "'order_id'=>$order_id"],
    credit_card_number: ["mcpIndrefund.SetPan(pan);", "mcpIndrefund.setPan(pan);", "'pan'=>$pan"],
    expiry_date: ["mcpIndrefund.SetExpdate(expiry_date);", "mcpIndrefund.setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    electronic_commerce_indicator: ["mcpIndrefund.SetCryptType(crypt);", "mcpIndrefund.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    
    version_number: ["mcpIndrefund.SetMCPVersion(\"MCP_VERSION_NUM\");", "mcpIndrefund.setMCPVersion(\"MCP_VERSION_NUM\");", "'mcp_version'=> $mcp_version"],
    cardholder_amount: ["mcpIndrefund.SetCardholderAmount(\"CARDHOLDER_AMOUNT\");", "mcpIndrefund.setCardholderAmount(\"CARDHOLDER_AMOUNT\");", "'cardholder_amount' => $cardholder_amount"],
    cardholder_currency_code: ["mcpIndrefund.SetCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "mcpIndrefund.setCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "'cardholder_currency_code' => $cardholder_currency_code"],

    customer_ID: ["mcpIndrefund.SetCustId(cust_id);", "mcpIndrefund.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["mcpIndrefund.SetDynamicDescriptor(dynamic_descriptor);", "mcpIndrefund.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    
    rate_token: ["mcpIndrefund.SetMCPRateToken(\"MCP_RATE_TOKEN\");", "mcpIndrefund.setMCPRateToken(\"MCP_RATE_TOKEN\");", "'mcp_rate_token' => $mcp_rate_token"],
}


export class IndependentRefund extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakeIndRefundRequest() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _MCP, orderId: newOrderId });
        const { storeId, apiToken, pan, expdate, amount, currency, mcpRateToken } = this.props;
        const indRefundRequest = { storeId, apiToken, orderId: newOrderId, pan, expdate, amount, currency, mcpRateToken };
        this.props.makeIndependentRefund(indRefundRequest);
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample MCP Independent Refund</h3>
                <IndependentRefundSample />
                <div className="requestButton" onClick={() => this.onMakeIndRefundRequest()}>
                    MCP Independent Refund Request
                </div> 
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Independent Refund</b></span>
                <p style={{marginTop: '3vh'}}>Credits a specified amount to the cardholder’s credit card. The credit card number and expiry date are mandatory.</p>
                <p>It is not necessary for the transaction that you are refunding to have been processed via the Moneris Gateway.</p>
                <p>This transaction request is the multi-currency pricing (MCP) enabled version of the equivalent financial transaction.</p>

                <div className="thingsToConsider">
                    <h3>Things to Consider: </h3>
                    <ul>
                        <li>Because of the potential for fraud, permission for this transaction is not granted to all accounts by default. If it is required for your business, it must be requested via your account manager.</li>
                    </ul>
                </div>

                <p><b>MCP Independent Refund transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>MCPIndependentRefund mcpIndrefund = new MCPIndependentRefund();</code>
                    case _JAVA:
                        return <code>MCPIndependentRefund mcpIndrefund = new MCPIndependentRefund();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_ind_refund', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for Independent Refund transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpIndrefund);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mcpIndrefund);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Independent Refund transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>credit card number</td>
                        <td><i>String</i><br /><br />max 20-character alphanumeric</td>
                        <td><code>{CODES.credit_card_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>expiry date</td>
                        <td><i>String</i><br /><br />4-character alphanumeric<br />(YYMM format)</td>
                        <td><code>{CODES.expiry_date[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP version number</td>
                        <td><i>String</i><br /><br />numeric<br /><br />current version is 1.0</td>
                        <td><code>{CODES.version_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder amount</td>
                        <td><i>String</i><br /><br />12-character numeric<br /><br />smallest discrete unit of foreign currency</td>
                        <td><code>{CODES.cardholder_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder currency code</td>
                        <td><i>String</i><br /><br />3-character numeric</td>
                        <td><code>{CODES.cardholder_currency_code[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>MCP Independent Refund transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor</td>
                        <td><i>String</i><br /><br />20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP rate token</td>
                        <td><i>String</i><br /><br />N/A</td>
                        <td><code>{CODES.rate_token[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken } = state.mcp.main.config;
    return { mode, storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {updateOrderId, makeIndependentRefund})(IndependentRefund)
